module.exports = __webpack_public_path__ + "img/personal-loans.0d6820f.svg";